import useEvents from "@/hooks/useEvents"
import { NestedEvent } from "@/types/serializers"
import CreatableRecordSelector from "./CreatableRecordSelector"

const EventSelector = ({
  eventId,
  selectedEventFallback,
  onChange,
  onBlur,
}: {
  eventId?: string
  selectedEventFallback?: NestedEvent | null
  onChange: any
  onBlur: any
}) => {
  const { events, createEventAsync } = useEvents()

  return (
    <CreatableRecordSelector
      createActionLabel="Create event"
      emptyActionLabel="an event"
      inputId="event-selector"
      label="Event"
      recordId={eventId}
      records={events}
      selectedRecordFallback={selectedEventFallback}
      onChange={onChange}
      onBlur={onBlur}
      onCreateAsync={createEventAsync}
    />
  )
}

export default EventSelector
